import type {
  ApiError,
  PriceHistoryResponse,
  PriceListResponse,
  PriceListSnapshot
} from "../shared/price-list";

export class ApiRequestError extends Error {
  constructor(
    message: string,
    public readonly status: number
  ) {
    super(message);
  }
}

async function request<T>(
  path: string,
  password: string,
  init?: RequestInit
): Promise<T> {
  const headers = new Headers(init?.headers);
  headers.set("authorization", "Bearer " + password);
  if (init?.body) {
    headers.set("content-type", "application/json");
  }

  const response = await fetch(path, {
    ...init,
    headers
  });
  const data = (await response.json()) as T | ApiError;

  if (!response.ok) {
    const message =
      "error" in (data as ApiError)
        ? (data as ApiError).error
        : "요청을 처리하지 못했습니다.";
    throw new ApiRequestError(message, response.status);
  }
  return data as T;
}

export function fetchPriceList(password: string): Promise<PriceListResponse> {
  return request<PriceListResponse>("/api/price-list", password);
}

export function savePriceList(
  password: string,
  snapshot: PriceListSnapshot
): Promise<PriceListResponse> {
  return request<PriceListResponse>("/api/price-list", password, {
    method: "POST",
    body: JSON.stringify(snapshot)
  });
}

export function fetchPriceHistory(
  password: string
): Promise<PriceHistoryResponse> {
  return request<PriceHistoryResponse>("/api/price-list/history", password);
}
